export type RowCompareFn<T> = (a: T, b: T) => number;

export class TableSorter<T> {
  public sortedColumnIndex: number | null = null;
  public ascending = true;

  constructor(private readonly compareFns: Map<number, RowCompareFn<T>>) { }

  public canSort(columnIndex: number): boolean {
    return this.compareFns.has(columnIndex);
  }

  public sort(columnIndex: number): void {
    if (!this.canSort(columnIndex)) {
      return;
    }
    if (columnIndex !== this.sortedColumnIndex) {
      this.sortedColumnIndex = columnIndex;
      this.ascending = true;
    } else if (this.ascending) {
      this.ascending = false;
    } else {
      this.sortedColumnIndex = null;
    }
  }

  public apply(rows: T[]): T[] {
    const compareFn = this.sortedColumnIndex === null ? undefined : this.compareFns.get(this.sortedColumnIndex);
    if (!compareFn) {
      return rows;
    }
    const factor = this.ascending ? 1 : -1;
    return [...rows].sort((a, b) => factor * compareFn(a, b));
  }

  public clone(): TableSorter<T> {
    const copy = new TableSorter(this.compareFns);
    copy.sortedColumnIndex = this.sortedColumnIndex;
    copy.ascending = this.ascending;
    return copy;
  }
}
